import React, { useState, useEffect, useCallback } from 'react';
import { TimeSliceGenerator } from '../../utils/TimeSliceGenerator'
import styled from 'styled-components'; // Or your preferred styling method
import "../pulse/PulsePage.css";

const timeSliceGenerator = new TimeSliceGenerator();

// --- Styled Components (Optional, replace with your CSS if not using) ---
const SelectContainer = styled.div`
  margin: 6px 0;
  font-family: sans-serif;
`;

// --- Utility for generating time options ---
// This function can live in a separate utility file if desired

// --- TimePicker Component ---

export interface TimePickerProps {
  /** The currently selected time string (HH:MM). */
  value?: string;
  /** The interval between time options in minutes. Defaults to 15. */
  intervalMinutes?: number;
  /** Callback function when a time is selected. Receives the selected time string (HH:MM). */
  onChange?: (selectedTime: string) => void;
  /** Optional ID for the select element. */
  id?: string;
  /** Optional class name for the container. */
  className?: string;
}

export const TimePicker: React.FC<TimePickerProps> = ({
  value = '00:00',
  intervalMinutes = 15,
  onChange,
  id,
  className
}) => {
  const [selectedTime, setSelectedTime] = useState<string>(value);
  const [timeOptions, setTimeOptions] = useState<string[]>([]);

  // Generate options and sync with external value prop
  useEffect(() => {

    const options = timeSliceGenerator.generateTimeOptions( '2h', intervalMinutes);
    setTimeOptions(options);

    // If the external value is a valid option, use it. Otherwise, don't change internal state.
    // This prevents the picker from resetting if the parent provides a value that's not on the interval.
    // A better approach might be to find the *closest* valid time.
    if (options.includes(value)) {
      setSelectedTime(value);
    }
  }, [intervalMinutes, value]);

  // Handle change event
  const handleChange = useCallback((event: React.ChangeEvent<HTMLSelectElement>) => {
    const newTime = event.target.value;
    setSelectedTime(newTime);
    if (onChange) {
      onChange(newTime);
    }
  }, [onChange]);

  return (
    // <SelectContainer className={className}>
    //   <label htmlFor={id}>Select Time: </label>
      <select className="pulse-datetime-selector" id={id} value={selectedTime} onChange={handleChange}>
        {timeOptions.map((time) => (
          <option key={time} value={time}>
            {time}
          </option>
        ))}
      </select>
    // </SelectContainer>
  );
};

export interface DatePickerProps {
  pickerDate: string;
  onDateChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  minSelectableDate: string;
  maxSelectableDate: string;
}

export const DatePicker: React.FC<DatePickerProps> = ( {
    pickerDate,
    onDateChange,
    minSelectableDate,
    maxSelectableDate,
}) => {

    return (
      <div style={{ height: 0, width: 0, overflow: 'hidden' }}> 
        <input
          id="nav-date-picker-input" // ID for the label to target
          type="date" 
        //   ref={dateInputRef}
          value={pickerDate}
          onChange={onDateChange}
          min={minSelectableDate}
          max={maxSelectableDate} // Limit selectable dates
          // style={{ opacity: 0, position: 'absolute', left: '-9999px', width: '1px', height: '1px' }}
          // No complex absolute positioning needed if it's inside a 0x0 div
          aria-hidden="true"
          tabIndex={-1}
        />
      </div>        
    );
}